import 'normalize.css'
import { createGlobalStyle } from 'styled-components'
import './fonts/fonts.scss'

export const GlobalStyle = createGlobalStyle`
  :root {
      --background-color: #ffffff;
      --background-secondary-color: #f9fafc;
      --text-color: #484848;
      --border-color: #494A4C;
  }

  html,
  body {
      margin: 0;
      padding: 0;
      width: 100%;
      font-family: 'e-Ukraine', sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      overflow-x: hidden;
      background-color: var(--background-secondary-color);
      box-sizing: border-box;
      min-height: 100vh;
      
      @media (max-width: 768px) {
          background-color: var(--background-color);
      }
  }

  #root {
      min-height: 100vh;
      //max-width: 1440px;
      width: 100%;
      display: flex;
      flex-direction: column;
      margin: 0 auto;
      justify-content: space-between;
      box-sizing: border-box;
      background-color: var(--background-secondary-color);

      @media (max-width: 768px) {
          background-color: var(--background-color);
      }
  }

  a {
      color: inherit;
      text-decoration: none;
  }

  .accessibility-mode {
      mix-blend-mode: luminosity;
      font-size: 18px;

      a {
          text-decoration: none; 
          transition: text-decoration 0.3s ease;
          &:hover {
              text-decoration: underline; 
          }
      }

      img {
          mix-blend-mode: luminosity;
      }
  }

`
